import React, { useState, useEffect } from "react";
import { func, string, shape, oneOf } from "prop-types";

const propTypes = {
  onCompletion: func,
  countdownEnd: string.isRequired,
  interval: oneOf(["seconds", "minutes", "hours", "days"]),
  dictionary: shape({
    days: string,
    hours: string,
    minutes: string,
    seconds: string,
  }),
};

const intervalTime = {
  seconds: 1000,
  minutes: 60000,
  hours: 3600000,
  days: 86400000,
};

const CountdownTicker = (props) => {
  const {
    dictionary,
    countdownEnd,
    interval = "seconds",
    onCompletion,
  } = props;

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const endTime = new Date(countdownEnd).getTime();

    const intervalObj = setInterval(() => {
      const now = new Date().getTime();
      const timeleft = endTime - now;

      if (timeleft < 0) {
        onCompletion();
        window.clearInterval(intervalObj);
        return;
      }

      // only update values if it is displayed
      if (dictionary.days) {
        // timeleft / (1000 * 60 * 60 * 24)
        setDays(
          Math.floor(timeleft / 86400000).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }),
        );
      }
      if (dictionary.hours) {
        // (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        setHours(
          Math.floor((timeleft % 86400000) / 3600000).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }),
        );
      }

      if (dictionary.minutes) {
        // (timeleft % (1000 * 60 * 60)) / (1000 * 60)
        setMinutes(
          Math.floor((timeleft % 3600000) / 60000).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }),
        );
      }
      if (dictionary.seconds) {
        // (timeleft % (1000 * 60)) / 1000
        setSeconds(
          Math.floor((timeleft % 60000) / 1000).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          }),
        );
      }
    }, intervalTime[interval]);

    return () => clearInterval(intervalObj);
  }, [countdownEnd, interval, dictionary, onCompletion]);

  return (
    <section className="countdown-ticker">
      {dictionary.days && (
        <div className="countdown-ticker__item">
          <div
            className="countdown-ticker__value"
            aria-labelledby="countdown-ticker__days"
          >
            {days}
          </div>
          <div className="countdown-ticker__label" id="countdown-ticker__days">
            {dictionary.days}
          </div>
        </div>
      )}
      {dictionary.days && (
        <div className="countdown-ticker__divider">&nbsp;</div>
      )}
      {dictionary.hours && (
        <div className="countdown-ticker__item">
          <div
            className="countdown-ticker__value"
            aria-labelledby="countdown-ticker__hours"
          >
            {hours}
          </div>
          <div className="countdown-ticker__label" id="countdown-ticker__hours">
            {dictionary.hours}
          </div>
        </div>
      )}
      {dictionary.minutes && dictionary.hours && (
        <div className="countdown-ticker__divider">:</div>
      )}
      {dictionary.minutes && (
        <div className="countdown-ticker__item">
          <div
            className="countdown-ticker__value"
            aria-labelledby="countdown-ticker__minutes"
          >
            {minutes}
          </div>
          <div
            className="countdown-ticker__label"
            id="countdown-ticker__minutes"
          >
            {dictionary.minutes}
          </div>
        </div>
      )}
      {dictionary.seconds && (dictionary.minutes || dictionary.hours) && (
        <div className="countdown-ticker__divider">:</div>
      )}
      {dictionary.seconds && (
        <div className="countdown-ticker__item">
          <div
            className="countdown-ticker__value"
            aria-labelledby="countdown-ticker__seconds"
          >
            {seconds}
          </div>
          <div
            className="countdown-ticker__label"
            id="countdown-ticker__seconds"
          >
            {dictionary.seconds}
          </div>
        </div>
      )}
    </section>
  );
};
CountdownTicker.propTypes = propTypes;
export default CountdownTicker;
